module.exports = __webpack_public_path__ + "img/second-0-opened.22c6b270.webp";